/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-toolkit-bl-icon',
    template: `<svg [ngClass]="cssClass || 'icon'"><use [attr.xlink:href]="'#it-' + icon"></use></svg>`,
    styleUrls: ['./bl-icon.component.scss']
})
export class SharedToolkitBLIconComponent {

    @Input() icon: string = '';
    @Input() cssClass: string = '';

}
